import { render, staticRenderFns } from "./SuggestedItemDepartments.vue?vue&type=template&id=62e1c91f&scoped=true"
import script from "./SuggestedItemDepartments.vue?vue&type=script&lang=js"
export * from "./SuggestedItemDepartments.vue?vue&type=script&lang=js"
import style0 from "./SuggestedItemDepartments.vue?vue&type=style&index=0&id=62e1c91f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e1c91f",
  null
  
)

export default component.exports